<script>
    import {afterUpdate} from "svelte";

    export let message = undefined;

    afterUpdate(() => {
        setTimeout(() => {message = undefined;}, 4200);
    });
</script>

<!--------------------------------------------------------------------------------------------------------------------->
{#if message}
    <h4 class={message.ok ? 'ok' : 'bad'}>{message.text}</h4>
{/if}

<!--------------------------------------------------------------------------------------------------------------------->

<style>
    h4 {
        width: inherit;
        margin: 0 auto;
        padding: 8px;
        border-radius: 7px;
        text-align: center;
        color: var(--white-color);
    }

    .ok {
        background-color: forestgreen;
    }

    .bad {
        background-color: red;
    }
</style>